// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2BE7e","imgAndText":"styles-module__imgAndText___3RAf_","image":"styles-module__image___2PZ4D","title":"styles-module__title___3Z4S9"};